import { Box } from '@mui/material';
import Loading from '@/component/mui/Backdrop';
import CommonSettingForm from '@/component/bet/CommonSettingForm';
import { useState } from 'react';

export default function BetGameSettingCommon() {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          padding: 2,
        }}
      >
        <CommonSettingForm />
      </Box>
      <Loading isLoading={isLoading} />
    </>
  );
}
